import DefaultDetail from "@Common/DefaultDetail";
import { inject, observer } from "mobx-react";

import "./style.scss";
import { getEditInputsByStep } from "../../config.jsx";

const Step6 = inject("mainStore")(
    observer(({ mainStore, setStep, step, countOfSteps }) => {
        const detailData = mainStore.getMainStore("detailData");

        const input = getEditInputsByStep({ mainStore, detailData }).step6 || [];

        return (
            <>
                <DefaultDetail apiUrl={"/promo/offers"} inputs={input} page={"offers"} setStep={setStep} step={step} countOfSteps={countOfSteps} />

                {/* <ScreenShotCompanent jsx={Step2} /> */}
            </>
        );
    }),
);

export default Step6;
